<template>
  <v-container class="max-width-1200">

    <v-row class="justify-center">
      <v-col>
        <!-- main text -->
        <v-row>
          <v-col class="pb-0 headline text-uppercase">
            {{ $t('common.about') }}
          </v-col>
        </v-row>
        <v-row>
          <v-col class="display-1">
            {{ $t('tao.about.subtitle')}}
          </v-col>
        </v-row>
        <v-row>
          <v-col class="text-justify">
            {{ $t('tao.about.text.01')}}
          </v-col>
        </v-row>
        <!-- pros checked -->
        <!-- <v-row class="py-8 max-width-1000 mx-auto">
          <v-col
            v-for="(item,index) in pros"
            :key="index"
            cols="12" sm="6"
            class="px-12">
            <v-row align="center">
              <v-col cols="2">
                <v-icon
                  size="42"
                  color="success">
                  mdi-checkbox-marked-outline
                </v-icon>
              </v-col>
              <v-col>
                {{ $t(item.text)}}
              </v-col>
            </v-row>
          </v-col>
        </v-row> -->
        <!-- example -->
        <v-row class="pt-8">
          <v-col class="display-1">
            {{ $t('tao.example.subtitle')}}
          </v-col>
        </v-row>
        <v-row>
          <v-col class="text-justify">
            {{ $t('tao.example.text')}}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="4"
              v-for="(item,index) in example"
              :key="index">
            <v-hover
              v-slot="{ hover }">
              <v-card
                :color="item.color"
                :elevation="hover ? 12 : 0"
                dark>
                <v-card-title class="display-1">
                  {{ $t(item.type) }}
                </v-card-title>
                <v-card-subtitle>
                  {{ $t("tao.example.amount.investment") }}
                </v-card-subtitle>
                <v-card-text>
                  <v-row>
                    <v-col>
                      {{ $t("tao.example.amount.percentage") }}
                    </v-col>
                    <v-col  class="text-end">
                      <b> {{ item.amount.percentage }} </b> %
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      {{ $t("tao.example.amount.perYear") }}
                    </v-col>
                    <v-col  class="text-end">
                      <b> {{ item.amount.perYear }} </b> HUF
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      {{ $t("tao.example.amount.total") }}
                    </v-col>
                    <v-col class="text-end title">
                      <b> {{ item.amount.total }} </b> HUF
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-hover>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
  import DataComponentBase from '@/commons/DataComponentBase';

  export default {
    name: 'TaoAbout',
    extends: DataComponentBase,

    data: () => ({
      pros: [
        // { text: "tao.about.pros.01" },
        // { text: "tao.about.pros.02" },
        // { text: "tao.about.pros.03" },
        // { text: "tao.about.pros.04" },
        // { text: "tao.about.pros.05" },
        // { text: "tao.about.pros.06" },
      ],
      example: [
        { color: "purple",  type: "tao.example.type.smallCompany",  amount: { percentage: "50", perYear: "100 000", total: "500 000" } },
        { color: "green",   type: "tao.example.type.middleCompany", amount: { percentage: "40", perYear:  "66 667", total: "400 000" } },
        { color: "blue",    type: "tao.example.type.bigCompany",    amount: { percentage: "30", perYear:  "50 000", total: "300 000" } },
      ],
    }),

    methods: {

    },
  }
</script>
